import '../../utils/index.js';
import createContextUtilities from '../../utils/createContextUtilities/createContextUtilities.js';

const {
  Provider: SelectContextProvider,
  useContext
} = createContextUtilities(null);
function useSelectContext(isOptional) {
  const context = useContext();
  if (!isOptional && !context) {
    throw Error('useContext must be called inside a provider or be initialized with a default value');
  }
  return context;
}

export { SelectContextProvider, useSelectContext as default };
